import { useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { Mail, RefreshCw, CheckCircle } from 'lucide-react';
import { useEmailVerification } from '../../api/hooks/useEmailVerification';
import { useAuth } from '../../contexts/AuthContext';

export function VerifyEmailPage() {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const { resendEmail, isResending, resendSuccess } = useEmailVerification();
  const [resent, setResent] = useState(false);

  const isVerified = !!user?.email_verified_at;

  const handleResend = () => {
    resendEmail();
    setResent(true);
  };

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  // Redirect if already verified
  if (isVerified) {
    return <Navigate to="/app/home" replace />;
  }

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="bg-background-card rounded-xl p-8 shadow-lg border border-border">
          {/* Icon */}
          <div className="flex justify-center mb-6">
            <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center">
              <Mail className="w-8 h-8 text-primary" />
            </div>
          </div>

          {/* Title */}
          <h1 className="text-2xl font-bold text-text-primary text-center mb-2">
            Check your email
          </h1>
          <p className="text-text-secondary text-center mb-2">
            We sent a verification link to
          </p>
          <p className="text-text-primary font-medium text-center mb-8">
            {user?.email}
          </p>

          {/* Success message */}
          {(resendSuccess || resent) && (
            <div className="flex items-center gap-2 bg-success/10 text-success rounded-lg p-3 mb-6">
              <CheckCircle className="w-5 h-5 flex-shrink-0" />
              <span className="text-sm">Verification email sent!</span>
            </div>
          )}

          {/* Resend button */}
          <button
            onClick={handleResend}
            disabled={isResending}
            className="w-full flex items-center justify-center gap-2 py-3 px-4 bg-background text-text-primary rounded-md font-medium border border-border hover:bg-background-alt disabled:opacity-50 transition-colors"
          >
            {isResending ? (
              <>
                <RefreshCw className="w-4 h-4 animate-spin" />
                Sending...
              </>
            ) : (
              <>
                <RefreshCw className="w-4 h-4" />
                Resend email
              </>
            )}
          </button>

          {/* Logout option */}
          <p className="mt-6 text-sm text-text-secondary text-center">
            Wrong email?{' '}
            <button
              onClick={handleLogout}
              className="text-primary hover:underline font-medium"
            >
              Sign out
            </button>
          </p>
        </div>
      </div>
    </div>
  );
}
